<div class="fini-modal" [class.active]="active()">
  <div class="close" *ngIf="closed.observed">
    <i class="material-symbols-outlined">close</i>
  </div>
  <div class="content" [class.relative]="relative" #content>
    <ng-content></ng-content>
  </div>
</div>
